import React from 'react';
import { useTheme } from '../../../contexts/ThemeContext';

const InterventionWarningModal = ({ isOpen, warnings, onClose }) => {
  const { isDarkMode } = useTheme();
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[10000] p-2 sm:p-4">
      <div
        className={`
          ${isDarkMode ? 'bg-gray-800 text-white' : 'bg-white text-gray-900'}
          rounded-2xl shadow-2xl w-full max-w-lg sm:max-w-3xl flex flex-col
        `}
        style={{ maxHeight: '90vh' }}
      >
        {/* Header */}
        <div className={`${isDarkMode ? 'bg-gradient-to-r from-gray-800 to-primary-900' : 'bg-gradient-to-r from-primary-600 to-primary-700'} px-4 sm:px-6 py-4 flex-shrink-0`}>
          <div className="flex items-center justify-between">
            <div className="flex items-center">
              <div className={`${isDarkMode ? 'bg-white bg-opacity-10' : 'bg-white bg-opacity-20'} w-10 h-10 rounded-xl flex items-center justify-center mr-3`}>
                <i className="fas fa-exclamation-triangle text-yellow-400 text-2xl"></i>
              </div>
              <div>
                <h2 className="text-xl font-bold text-white">Avertissements lors de la clôture</h2>
                <p className={`${isDarkMode ? 'text-gray-300' : 'text-primary-100'} text-sm`}>Merci de vérifier les éléments suivants avant de clôturer.</p>
              </div>
            </div>
            <button
              onClick={onClose}
              className="text-white hover:bg-white hover:bg-opacity-20 rounded-lg p-2 transition-colors"
            >
              <i className="fas fa-times text-xl"></i>
            </button>
          </div>
        </div>
        {/* Content */}
        <div className="flex-1 p-2 sm:p-8 overflow-y-auto max-h-[60vh]">
          {(!warnings || warnings.length === 0) ? (
            <div className="text-center text-lg font-medium py-8">Aucun avertissement à afficher.</div>
          ) : (
            <div className="w-full overflow-x-auto">
              <table className="min-w-full border divide-y divide-gray-200 text-base">
                <thead>
                  <tr className={isDarkMode ? 'bg-gray-900' : 'bg-primary-50'}>
                    <th className="px-4 py-3 text-left">Désignation</th>
                    <th className="px-4 py-3 text-left">Type</th>
                    <th className="px-4 py-3 text-left">Capacité</th>
                    <th className="px-4 py-3 text-left">Code à barres</th>
                    <th className="px-4 py-3 text-left">Observation</th>
                    <th className="px-4 py-3 text-left">Marque</th>
                    <th className="px-4 py-3 text-left">Date fabrication</th>
                  </tr>
                </thead>
                <tbody>
                  {warnings.map((item) => (
                    <tr key={item.id} className={isDarkMode ? 'border-b border-gray-700' : 'border-b border-gray-200'}>
                      <td className="px-4 py-3">{item.designation}</td>
                      <td className="px-4 py-3">{item.typeArticle?.designation || ''}</td>
                      <td className="px-4 py-3">{item.capacite}</td>
                      <td className="px-4 py-3">{item.codeABarre}</td>
                      <td className="px-4 py-3">{item.observation}</td>
                      <td className="px-4 py-3">{item.marque}</td>
                      <td className="px-4 py-3">{item.datetimeFabrication ? new Date(item.datetimeFabrication).toLocaleDateString('fr-FR') : ''}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
        {/* Footer */}
        <div className={`border-t px-4 sm:px-6 py-4 flex-shrink-0 flex justify-end gap-3 ${isDarkMode ? 'border-gray-700 bg-gray-900' : 'border-gray-200 bg-gray-50'}`}>
          <button
            type="button"
            onClick={onClose}
            className={`px-6 py-3 rounded-lg transition-colors font-medium border ${isDarkMode ? 'text-gray-200 bg-gray-800 border-gray-700 hover:bg-gray-700' : 'text-gray-600 bg-white border-gray-300 hover:bg-gray-50'}`}
          >
            <i className="fas fa-check mr-2"></i>
            Fermer
          </button>
        </div>
      </div>
    </div>
  );
};

export default InterventionWarningModal;
